import { render } from "./CanvasContainer.vue?vue&type=template&id=148d837c&scoped=true"
import script from "./CanvasContainer.vue?vue&type=script&lang=js"
export * from "./CanvasContainer.vue?vue&type=script&lang=js"

import "./CanvasContainer.vue?vue&type=style&index=0&id=148d837c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148d837c"]])

export default __exports__